import { render, staticRenderFns } from "./modal-explainer.vue?vue&type=template&id=03340c51&scoped=true"
import script from "./modal-explainer.vue?vue&type=script&lang=js"
export * from "./modal-explainer.vue?vue&type=script&lang=js"
import style0 from "./modal-explainer.vue?vue&type=style&index=0&id=03340c51&prod&lang=scss"
import style1 from "./modal-explainer.vue?vue&type=style&index=1&id=03340c51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03340c51",
  null
  
)

export default component.exports